import GuidedScipRegulationContent from './GuidedScipRegulationContent.vue'
import GuidedSubstanceRegulationContent from './GuidedSubstanceRegulationContent.vue'

const GuidedRegulationContentVariant = Object.freeze({
    SCIP_V1: 'scip-v1',
    SUBSTANCE_V1: 'substance-v1',
})

const GUIDED_REGULATION_CONTENT_REGISTRY = Object.freeze({
    [GuidedRegulationContentVariant.SCIP_V1]: GuidedScipRegulationContent,
    [GuidedRegulationContentVariant.SUBSTANCE_V1]: GuidedSubstanceRegulationContent,
})

const resolveGuidedRegulationContent = variant => (
    GUIDED_REGULATION_CONTENT_REGISTRY[variant] || null
)

export {
    GuidedRegulationContentVariant,
    resolveGuidedRegulationContent,
}
